/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The cost of some or all of a timesheet entry.
 * @export
 * @interface TimesheetEntryCost
 */
export interface TimesheetEntryCost {
    /**
     * 
     * @type {number}
     * @memberof TimesheetEntryCost
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof TimesheetEntryCost
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof TimesheetEntryCost
     */
    employeePayDetailId: number | null;
    /**
     * 
     * @type {Date}
     * @memberof TimesheetEntryCost
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof TimesheetEntryCost
     */
    endTime: Date | null;
    /**
     * 
     * @type {number}
     * @memberof TimesheetEntryCost
     */
    hourlyRate: number | null;
    /**
     * 
     * @type {number}
     * @memberof TimesheetEntryCost
     */
    cost: number | null;
}

/**
 * Check if a given object implements the TimesheetEntryCost interface.
 */
export function instanceOfTimesheetEntryCost(value: object): value is TimesheetEntryCost {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('employeePayDetailId' in value) || value['employeePayDetailId'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    if (!('hourlyRate' in value) || value['hourlyRate'] === undefined) return false;
    if (!('cost' in value) || value['cost'] === undefined) return false;
    return true;
}

export function TimesheetEntryCostFromJSON(json: any): TimesheetEntryCost {
    return TimesheetEntryCostFromJSONTyped(json, false);
}

export function TimesheetEntryCostFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimesheetEntryCost {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'employeePayDetailId': json['employeePayDetailId'],
        'startTime': (new Date(json['startTime'])),
        'endTime': (json['endTime'] == null ? null : new Date(json['endTime'])),
        'hourlyRate': json['hourlyRate'],
        'cost': json['cost'],
    };
}

  export function TimesheetEntryCostToJSON(json: any): TimesheetEntryCost {
      return TimesheetEntryCostToJSONTyped(json, false);
  }

  export function TimesheetEntryCostToJSONTyped(value?: TimesheetEntryCost | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'employeePayDetailId': value['employeePayDetailId'],
        'startTime': ((value['startTime']).toISOString()),
        'endTime': (value['endTime'] == null ? null : (value['endTime'] as any).toISOString()),
        'hourlyRate': value['hourlyRate'],
        'cost': value['cost'],
    };
}

